import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { MenuPreferenceService } from "src/service/menu-preference.service";
import { BUILDING_SERVICES, BuildingService } from "src/model/class/general classes/building-services";
import { UsersRole } from "src/model/enum/enumDigitalPlace";
import { App } from "@capacitor/app";
import { MenuController, Platform } from "@ionic/angular";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { Subscription } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { ClientSettings } from "src/model/class/client-settings";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { CurrentSessionData } from "src/model/class/general classes/current-session-data";
import { Building } from "src/components/shared-components/class/general-classes/building";
import { Gateway } from "src/components/shared-components/class/general-classes/gateway";
import { Supervision } from "src/model/class/general classes/supervision";
import { Settings } from "src/model/class/settings";
import { BIGDeviceOperationMode } from "src/components/shared-components/enum/enumDevice";
import { GatewayKind } from "src/components/shared-components/enum/enumGateway";
import { LogLevel } from "src/components/shared-components/enum/enumLog";
import { ApplicationTheme } from "src/components/shared-components/enum/enumMisc";
import { ConnectionType } from "src/components/shared-components/enum/enumSettings";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import { GenericUserData } from "src/model/interface/generic-user-data";
import { iEvent } from "src/components/shared-components/interfaces/iEvent";
import { MenuExpandableCollapsedItems } from "src/model/interface/menu-expandable";
import { SupervisionPipe } from "src/pipes/supervision-name.pipe";
import { BIGService } from "src/service/big.service";
import { DpAuthenticationService } from "src/service/dp-authentication.service";
import { DpBuildingService } from "src/service/building.service";
import { GatewayService } from "src/service/gateway.service";
import { LoggerService } from "src/service/logger.service";
import { NetworkService } from "src/service/network.service";
import { PopupService } from "src/service/popup.service";
import { SecuretyDataProtectionService } from "src/service/securety-data-protection.service";
import { SupervisionService } from "src/service/supervision.service";
import { SystemRouterService } from "src/service/system-router.service";
import { ThemeService } from "src/service/theme.service";
import { currentBuildingUnsetAction } from "src/components/shared-components/state/actions/building.action";
import { isHydrated } from "src/state/hydrate";
import { currentUserData } from "src/state/selectors/authentication.selectors";
import { selectedBuilding } from "src/components/shared-components/state/selectors/building.selector";
import { clientSettings } from "src/state/selectors/client-settings.selectors";
import { listGateway } from "src/state/selectors/gateway.selectors";
import { serverSettings } from "src/state/selectors/server-settings-selector";

@Component({
    selector: "app-menu-web-digital-place",
    templateUrl: "./menu-web-digital-place.component.html",
    styleUrls: ["./menu-web-digital-place.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MenuWebDigitalPlaceComponent implements OnInit, OnDestroy, iEvent {
  private _logContext: string = "Menu-web-digital-place.component";

  //#region Subcriptions to "_store.select(...)" Observables
  private _clientSettingSubscription: Subscription = null;
  private _selectserverSettingsSub: Subscription = null;
  private _selectedPlantSubscription: Subscription = null;
  private _selectCurrentUserSub: Subscription = null;

  //#endregion

  private _supervisionListSubscription: Subscription = null;
  private _clientSettings: ClientSettings = null;

  private _generalSettings: Settings = null;

  public listSupervisions: Array<Supervision> = null;
  private _currentConnectionType: ConnectionType = ConnectionType.NONE;

  public _eventSubscriptions: Array<Subscription> = null;
  public menuExpandable: MenuExpandableCollapsedItems = null;

  public currentBuilding: Building = null;
  /** Address of the page on screen, to highlight its entry */
  public currentUrl: string = "";
  private _routerSubscription: Subscription = null;
  public userUsername: string = "";
  public kioskModeEnable: boolean = false;
  public currentUser: CurrentSessionData = null;

  public showVideoCamera: boolean = false;
  public showReportPayment: boolean = false;
  public showScanAndGo: boolean = true;
  public showAccessControl: boolean = false;
  public showFastCheckIn: boolean = true;
  public showReadTag: boolean = false;
  public showReportCustomerStaff: boolean = true;
  public showMyAccesses: boolean = true;
  public showReportKeys: boolean = true;
  public showMyQRCode: boolean = true;
  public showReportAlarms: boolean = true;
  public showReportAccesses: boolean = true;
  public showReportPresences: boolean = true;
  public showLastNotification: boolean = true;
  public showDrawTemplateHTML: boolean = false;
  public showLoadControl: boolean = false;
  public showAddresses: boolean = false;
  public showConfiguration: boolean = false;

  public showScenarioMenu: boolean = false;
  public showSchedulationMenu: boolean = false;

  public showWeeklyPlanningMenu: boolean = false;
  public showVideoCameraMenu: boolean = false;
  public showReportPaymentMenu: boolean = false;
  public showScanAndGoMenu: boolean = false;
  public showAccessControlMenu: boolean = false;
  public showFastCheckInMenu: boolean = false;
  public showReadTagMenu: boolean = false;
  public showReportCustomerStaffMenu: boolean = false;
  public showMyAccessesMenu: boolean = false;
  public showReportKeysMenu: boolean = false;
  public showMyQRCodeMenu: boolean = false;
  public showReportAlarmsMenu: boolean = false;
  public showReportAccessesMenu: boolean = false;
  public showReportPresencesMenu: boolean = false;
  public showLastNotificationMenu: boolean = false;

  public showConfigurationMenu: boolean = false;
  public showValidListMenu: boolean = false;
  public showHistoryTransitMenu: boolean = false;
  public showAccessControlMenuMaster: boolean = false;

  public iconConnection: string = "globe-outline";
  public cssConnectionClass: string = "";
  public cssVersionClass: string = "";

  public urlLogo: string = "";
  public appVersion: string = "";
  public isLargeScreen: boolean = false;
  public isApp: boolean = false;
  public isAppAndroid: boolean = false;
  public enumBIGDeviceOperationMode = BIGDeviceOperationMode;
  public isBigStudio: boolean = false;
  public isExpandedTerms: boolean = false;

  public Gateways: Gateway[];

  constructor(
    private _networkService: NetworkService,
    private _securetyDataProtectionService: SecuretyDataProtectionService,
    private _DPauthService: DpAuthenticationService,
    private _platform: Platform,
    private _systemRouterService: SystemRouterService,
    private _translateService: TranslateService,
    private _loggerService: LoggerService,
    private _store: Store,
    private _popupService: PopupService,
    private _gatewayService: GatewayService,
    private _menuController: MenuController,
    private _themeService: ThemeService,
    private _bigService: BIGService,
    private _dpBuildingService: DpBuildingService,
    private _supervisionPipe: SupervisionPipe,
    private _router: Router,
    private _menuPreferenceService: MenuPreferenceService
  ) {
    this.isApp = this._platform.is("android") || this._platform.is("ios");
    this.isAppAndroid = this._platform.is("android");
    this.isLargeScreen = this._platform.width() >= 768;
  }

  /**
   * The "back to the building list" menu item is shown on every page EXCEPT
   * when already on the building list page itself (where it would be pointless).
   */
  public get showComeBackToCondominium(): boolean {
    return !this._systemRouterService.isOnDigitalPlaceListBuilding();
  }

  async ngOnInit() {
    this.currentUrl = this._router.url;
    this._routerSubscription = this._router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => (this.currentUrl = event.urlAfterRedirects));

    this.initializeMenuExpandable();
    this.getCurrentTheme();
    //#region Initialialise/load data from Store
    await this.checkIsStoreReady();

    this.loadCurrentBuildingData();
    this.loadCurrentUserData();

    this.loadAppVersion();
    this.loadGateway();
    //#endregion

    this.subscribeSettingServiceData();

    this.subscribeEvents();

    this.subscribeNetworkServiceData();
  }

  ngOnDestroy() {
    this._routerSubscription?.unsubscribe();
    this.unsubscribeEvents();

    if (this._supervisionListSubscription) {
      this._supervisionListSubscription.unsubscribe();
    }

    this.unsubscribeStoreSelect();
  }

  //#region Subscribe to event-service observable ///
  subscribeEvents(): void {
    this._eventSubscriptions = new Array<Subscription>();
  }

  unsubscribeEvents(): void {
    for (let sub of this._eventSubscriptions) {
      sub.unsubscribe();
    }
  }

  //#endregion

  /**
   * The page on screen is this one (or one of its sub-pages)
   *
   * @param path address of the menu entry, e.g. "/reserved-area/settings"
   */
  /**
   * Services of the building in the menu: those enabled by the settings (on the demo building only
   * the ones the dashboard opens there too)
   */
  public get menuServices(): Array<BuildingService> {
    if (!this.currentBuilding || !this._generalSettings) {
      return [];
    }
    const isDemo = this.currentBuilding.default && this.currentUser?.role !== UsersRole.SUPER_ADMIN;
    return BUILDING_SERVICES.filter(
      (service) => service.isEnabled(this._generalSettings) && (!isDemo || service.allowedInDemo)
    );
  }

  /** The page on screen belongs to this service */
  public isServiceActive(service: BuildingService): boolean {
    return service.match.test(this.currentUrl.split(/[?#]/)[0]);
  }

  /** Open a service of the building */
  public onClickGoToService(service: BuildingService): void {
    this._menuController.close();
    this._router.navigateByUrl(service.path(this.currentBuilding.idAreaLocal));
  }

  /** The group of the services is open */
  public get isServicesOpen(): boolean {
    return this._menuPreferenceService.isServicesOpen;
  }

  /** Open / close the group of the services (the choice is remembered) */
  public onClickToggleServices(): void {
    this._menuPreferenceService.setServicesOpen(!this.isServicesOpen);
  }

  /** The menu is pinned open on wide screens */
  public get isMenuPinned(): boolean {
    return this._menuPreferenceService.isPinned;
  }

  /** Pin / unpin the menu (wide screens) */
  public onClickTogglePin(): void {
    this._menuPreferenceService.setPinned(!this.isMenuPinned);
  }

  public isActive(path: string): boolean {
    const url = this.currentUrl.split(/[?#]/)[0];
    return url === path || url.startsWith(path + "/");
  }

  public onClickGoUserDetails() {
    this.closeMenu();
    this._systemRouterService.navigateToDigitalPlaceUserDetails();
  }

  /**
   * Redirect to Home Page
   */
  public onClickGoHome(): void {
    this.closeMenu();
    this._systemRouterService.navigateToDigitalPlaceHome();
  }

  /**
   * Redirect to supervision
   * @param id
   */
  public onClickGoSupervision(id: number, idEnvironment: number) {
    this.closeMenu();
    this._systemRouterService.navigateToSupervisionGraph(id, idEnvironment);
  }

  /**
   * Redirect to bills page
   */
  public onClickGoToBills(): void {
    this.closeMenu();
    this._systemRouterService.navigateToManageBills();
  }

  /**
   * Redirect to quotes page
   */
  public onClickGoToQuotes(): void {
    this.closeMenu();
    this._systemRouterService.navigateToManageQuotes();
  }

  /**
   * Redirect to Consumption management page
   */

  public onClickGoToConsumptionManagement(): void {
    this.closeMenu();
    this._systemRouterService.navigateToConsumptionManagement();
  }

  /**
   * Redirect to option page
   */
  public onClickGoToOptions(): void {
    this.closeMenu();

    this._systemRouterService.navigateToSystemOptionSettings();
  }

  /**
   * Expand menu for show all terms
   */
  public onClickToggleExpandTerms(): void {
    this.isExpandedTerms = !this.isExpandedTerms;
  }

  /**
   * Redirect to accesses
   */
  public onClickGotoAccesseList(): void {
    this._systemRouterService.navigateToListUserAccess();
  }

  /**
   * Redirect to scan and go page
   */
  public onClickGoToScanAndGo(): void {
    this._systemRouterService.navigateToAccessControlScanAndGo();
  }

  /**
   * Redirect to user qr codes
   */
  public onClickGoToUserQRCodes(): void {
    this._systemRouterService.navigateToUserQrCodes();
  }

  /**
   * Redirect to list customer page
   */
  public onClickGoToListCustomer(): void {
    this._systemRouterService.navigateToListCustomerStaff();
  }

  /**
   * Redirect to list cards
   */
  public onClickGoToListCard(): void {
    this._systemRouterService.navigateToListCard();
  }

  /**
   * Redirect to editor html page
   */
  public onClickGotoReportHTML(): void {
    this._systemRouterService.navigateToReportHTML();
  }

  /**
   * Redirect to generation payment page
   */
  public onClickGotoPaymentGeneration(): void {
    this._systemRouterService.navigateToPaymentGeneration();
  }

  /**
   * Redirect to payment page
   */
  public onClickGotoReportPayment(): void {
    this._systemRouterService.navigateToReportPayment();
  }

  /**
   * Redirect to load control page
   */
  public onClickGotoLoadControl(): void {
    this._systemRouterService.navigateToLoadControl();
  }

  /**
   * Handle come back to building list of condominium in digital place menu
   */
  public onClickGoListCondominium(): void {
    //this._store.dispatch(currentBuildingUnsetAction());

    this._dpBuildingService.deselectCurrentBuilding();
    this.closeMenu();

    this._systemRouterService.navigateToDigitalPlaceListBuilding();
  }

  /**
   * Redirect to Direct-access URLs configuration page
   */
  public onClickGotoDirectAccessURLconfiguration(): void {
    this._systemRouterService.navigateToDirectAccessURLConfiguration();
  }

  /**
   * Redirect to camera page
   */
  public onClickGoToCameras(): void {
    this._systemRouterService.navigateToListCameras();
  }

  /**
   * Redirect to log comunication push page
   */
  public onClickGoToLogCommunicationPush(): void {
    this._systemRouterService.navigateToLogCommunicationPush();
  }

  /**
   * Redirect to alarms history page
   */
  public onClickGoToAlarmsHistory(): void {
    this._systemRouterService.navigateToAlarmsHistory();
  }

  /**
   * Navigate to access control fast checkin
   */
  public onClickNavigateToAccessControlFastCheckin(): void {
    this._systemRouterService.navigateToAccessControlFastCheckIn();
  }

  /**
   * Navigate to access control read tag
   */
  public onClickNavigateToAccessControlReadCard(): void {
    this._systemRouterService.navigateToAccessControlReadCard();
  }

  /**
   * Navigate to access control access history
   */
  public onClickNavigateToAccessControlAccessHistory(): void {
    this._systemRouterService.navigateToAccessControlAccessHistory();
  }

  /**
   * Navigate to access control presence history
   */
  public onClickNavigateToAccessControlPresenceHistory(): void {
    this._systemRouterService.navigateToAccessControlPresenceHistory();
  }

  /**
   * Redirect to valid list handle page
   */
  public async onClickGoToReportValidLists(): Promise<void> {
    if (await this.enterDeviceAdvanceSettingsArea()) {
      this._systemRouterService.navigateToReportDeviceValidList();
    }
  }

  /**
   * Redirect to history transit page
   */
  public async onClickGoToReportHistoryTransit(): Promise<void> {
    if (await this.enterDeviceAdvanceSettingsArea()) {
      this._systemRouterService.navigateToReportDeviceHistoryTransit();
    }
  }

  /**
   * Perform logout operation.
   * When no connection detected, it not perform API call loguout call
   */
  public async onClickLogout(): Promise<void> {
    await this.closeMenu();
    this.closeMenuExpandable();

    /*
    const performLogoutApiCall =
    this._currentConnectionType !== ConnectionType.NONE;

    await this._DPauthService.logout(performLogoutApiCall);
    */

    //NOTE: The value "true" is used here for development purpose. In final draft, see if necessary to choose depending on
    //connection state to server or not.
    await this._DPauthService.logout(true);
  }

  /**
   * when click on menu, open the menu and close the others
   *
   * @param menuName name of the menu item
   */
  public onClickExpandMenu(menuName: string): void {
    if (!this.menuExpandable[menuName]) {
      this.menuExpandable[menuName] = true;
    } else {
      this.menuExpandable[menuName] = false;
    }
  }

  /**
   * Return if device is mobile devices
   *
   * @returns
   */
  public isMobileDevices(): boolean {
    let response: boolean = false;

    if (
      (this._platform.is("ios") || this._platform.is("android")) &&
      !this._bigService.isQ5Model
    ) {
      response = true;
    }

    return response;
  }

  /**
   * Open script for chat when clicking the button
   */
  public onClickOpenChat(): void {
    const link = document.createElement("a");
    link.href = this._platform.is("ios")
      ? "https://tawk.to/chat/67c1bbf6686bed190aff3e78/1il6cceof"
      : "javascript:void(Tawk_API.toggle())";
    link.click();
  }

  public showMenu(menu: string): boolean {
    return true;
  }

  /**
   * This method check if the NgRx store has already been initialised (IE. hydrated) from the local storage.
   * It does so observing the value of the "hydrated" feature; the method shall not teminate until this feature
   * change its value to TRUE.
   */
  private async checkIsStoreReady(): Promise<boolean> {
    return this._store
      .select(isHydrated)
      .pipe(
        filter((isHydrated: boolean) => isHydrated),
        take(1)
      )
      .toPromise();
  }

  /**
   * Initialzie menu expandable entry (default all calpsed)
   */
  private initializeMenuExpandable(): void {
    this.menuExpandable = {
      programmations: true,
      report: true,
      config: true,
      addresses: true,
      accessControl: true,
      gateway: true,
      terms: true,
    };
  }

  /**
   * Redirect to terms of service page
   */
  public onClickGoToConditions(): void {
    this._systemRouterService.navigateToConditionsOfService();
  }

  /**
   * Redirect to privacy policy page
   */
  public onClickGoToPrivacyPolicy(): void {
    this._systemRouterService.navigateToPrivacyPolicy();
  }

  /**
   * Redirect to DPA page
   */
  public onClickGoToDPA(): void {
    this._systemRouterService.navigateToDPA();
  }

  /**
   * Redirect to cookie policy page
   */
  public onClickGoToCookiePolicy(): void {
    this._systemRouterService.navigateToCookiePolicy();
  }

  /**
   * Handle permission to enter area containing sensible, "Administrator-restricted" settings/data
   */
  private async enterDeviceAdvanceSettingsArea(): Promise<boolean> {
    let returnValue: boolean = false;

    if (this._clientSettings) {
      const devPassword: string = (this._clientSettings.adminDevicePassword ??=
        AppSettings.DEFAULT_DEVICE_ADMIN_PASSWORD);
      //
      try {
        const passwordOk =
          await this._popupService.showModalRequestNumericPassword(devPassword);

        if (passwordOk) {
          //
          returnValue = true;
        }
      } catch (exception) {
        this._loggerService.log(
          LogLevel.LOG_ERROR,
          this._logContext,
          "react to change to adminDevicePassword",
          "subscribeFormChangeValueEvent()",
          "ERROR: " + exception.message
        );

        returnValue = false;
      }
    }

    return returnValue;
  }

  /**
   * Load appliceation version
   */
  private async loadAppVersion(): Promise<void> {
    try {
      this.appVersion = (await App.getInfo()).version;

      if (this.appVersion) {
        this.cssVersionClass = "with-version";
      }
    } catch (exception) {}
  }

  /**
  Estabilish subscription to "clientSettings" Store feature (which stores the info about the general app
 * -related settings as defined for this device).
   */
  private subscribeSettingServiceData(): void {
    this._clientSettingSubscription = this._store
      .select(clientSettings)
      .pipe(
        filter((clientSetting) => clientSetting !== null)
        //filter(() => this._generalSettings != null)
      )
      .subscribe((clientSettings: ClientSettings) => {
        this._clientSettings = clientSettings;

        this.kioskModeEnable = clientSettings.kioskMode;

        this.setStylePatternLogo();
      });
  }

  /**
   * Subscribe to network service data
   */
  private subscribeNetworkServiceData(): void {
    this._networkService.currentConnectionType.subscribe(
      (currentConnectionType: ConnectionType) => {
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          " _networkService ",
          " currentConnectionType ",
          "Current connection: " + ConnectionType[currentConnectionType]
        );

        this._currentConnectionType = currentConnectionType;

        this.calculateConnectionClass(currentConnectionType);
      }
    );
  }

  /**
   * Hide show each menu entry
   */
  private retryLevelProtection() {
    try {
      this.showVideoCamera = this._generalSettings?.ShowVideoCamerasSection;
      this.showReportPayment = this._generalSettings?.ShowReport_Payments;
      this.showFastCheckIn = this._generalSettings?.ShowFastCheckIn;
      this.showReadTag = this._generalSettings?.ShowReadTag;
      this.showAccessControl = this._generalSettings?.ShowAccessControl;
      this.showReportCustomerStaff =
        this._generalSettings?.ShowReport_CustomerStaff;
      this.showReportKeys = this._generalSettings?.ShowReport_Keys;
      this.showScanAndGo = this._generalSettings?.ShowScanAndGo;
      this.showMyAccesses = this._generalSettings?.ShowMyAccesses;
      this.showMyQRCode = this._generalSettings?.ShowMyQRCode;
      this.showReportAlarms = this._generalSettings?.ShowReport_Alarms;
      this.showReportAccesses = this._generalSettings?.ShowReport_Accesses;
      this.showReportPresences = this._generalSettings?.ShowReport_Presences;
      this.showLastNotification = this._generalSettings?.ShowLastNotification;
      this.showDrawTemplateHTML = this._generalSettings?.ShowDrawTemplateHTML;
      this.showLoadControl = this._generalSettings?.ShowLoadControl;
      this.showAddresses = this._generalSettings?.ShowReport_ShowAddresses;
      this.showConfiguration = this._generalSettings?.ShowConfiguration;
    } catch (exception) {}
  }

  /**
 Estabilish subscription to "serverSettings" Store feature (which stores the info about visibility permission on the menù subsections:
 * each item of the menu is visible only if the user has the permission)
   */
  private loadSettingsData(): void {
    this._selectserverSettingsSub = this._store
      .select(serverSettings)
      .pipe(filter((serverSetting) => serverSetting !== null))
      .subscribe((serverSetting: any) => {
        this._generalSettings = serverSetting;
        this._loggerService.log(
          LogLevel.LOG_INFO,
          this._logContext,
          "_store.select(serverSettings)",
          "loadSettingsData()",
          "serverSettings: " + JSON.stringify(serverSetting)
        );

        this.retryLevelProtection();
      });
  }

  /**
   * Load list of gateawys
   */
  public loadGateway() {
    this._gatewayService.Initialize();
    this._store
      .select(listGateway)
      .pipe(
        filter(
          (listGateway: GenericStoreApiData) =>
            listGateway !== null && listGateway !== undefined
        ),
        filter((listGateway: GenericStoreApiData) => listGateway?.loaded),
        filter(
          (listGatewayStore: GenericStoreApiData) =>
            !(
              listGatewayStore.errorGeneric ||
              listGatewayStore.errorNotYetImplemented
            )
        )
      )
      .subscribe((listGatewayObject: GenericStoreApiData) => {
        const data = listGatewayObject.data?.data || [];
        this.Gateways = data.filter(
          (g: Gateway) =>
            g.kind != GatewayKind.MASTER &&
            g.kind != GatewayKind.VIRTUAL_VARIABLE &&
            g.kind != GatewayKind.OMNIA
        );
      });
  }

  /**
   * Load current building data
   */
  private loadCurrentBuildingData(): void {
    this._selectedPlantSubscription = this._store
      .select(selectedBuilding)
      .subscribe((currentBuilding: Building) => {
        this.currentBuilding = currentBuilding;
        this.loadSettingsData();
      });
  }

  /**
   * Load current user data
   */
  private loadCurrentUserData(): void {
    this._selectCurrentUserSub = this._store
      .select(currentUserData)
      .pipe(
        filter((currentUserData: GenericUserData) => currentUserData !== null),
        map((currentUserData: GenericUserData) => currentUserData?.currentUser)
      )
      .subscribe((currentUser: CurrentSessionData) => {
        this.currentUser = currentUser;

        if (currentUser != null) {
          this.userUsername = this._securetyDataProtectionService.decypt(
            currentUser.username,
            null
          );
        }
      });
  }

  //#region Unsubscribe from "_store.selec(...)" Observable

  /**
   * This method handles the unsunìbscription from the Observables returned by the "_store.select(...)" invocations.
   * It SHOULD BE CALLED EACH TIME THE DATA STREAMS ARE NOT NEEDED ANYMORE; this means in:
   *
   * * OnDestroy() [Components/Services]
   * * OnViewWillLeave() [Pages]
   */
  private unsubscribeStoreSelect(): void {
    if (this._clientSettingSubscription) {
      this._clientSettingSubscription.unsubscribe();
    }

    if (this._selectserverSettingsSub) {
      this._selectserverSettingsSub.unsubscribe();
    }

    if (this._selectedPlantSubscription) {
      this._selectedPlantSubscription.unsubscribe();
    }

    if (this._selectCurrentUserSub) {
      this._selectCurrentUserSub.unsubscribe();
    }
  }

  //#endregion

  private closeMenuExpandable(): void {
    this.menuExpandable.report = true;
    this.menuExpandable.config = true;
    this.menuExpandable.addresses = true;
    this.menuExpandable.accessControl = true;
    this.menuExpandable.programmations = true;
  }

  /**
   * Calcualte CSS class to assign to connection type icon
   *
   * @param connectionType
   */
  private calculateConnectionClass(connectionType: ConnectionType): void {
    this.cssConnectionClass = "connecting";
    this.iconConnection = "globe-outline";

    switch (connectionType) {
      case ConnectionType.NONE:
        this.cssConnectionClass = "no-connection";
        break;
      case ConnectionType.WAN:
        this.cssConnectionClass = "connected";
        break;
      case ConnectionType.LAN:
        this.cssConnectionClass = "connected";
        this.iconConnection = "wifi-outline";
        break;
      case ConnectionType.LANWAN:
        this.cssConnectionClass = "connected";
        break;
      default:
        break;
    }
  }

  /**
   * Close menu
   */
  private async closeMenu(): Promise<void> {
    await this._menuController.close();
  }

  /**
   * Set stule pattern logo
   */
  private setStylePatternLogo(): void {
    this.urlLogo = this._themeService.getPatternByApplicationTheme();

    this._loggerService.log(
      LogLevel.LOG_INFO,
      this._logContext,
      this._logContext,
      "setStylePatternLogo() ",
      "pattern: " + this._themeService.getPatternByApplicationTheme()
    );
  }
  //

  /**
   * Get current theme and set variabile to show/hide video of bigstudio on left
   */
  private getCurrentTheme() {
    if (this._themeService.applicationTheme == ApplicationTheme.BIG) {
      this.isBigStudio = true;
    }
  }
}
